import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { IntlProvider, useIntl } from 'react-intl';

import { getDefault404Message } from 'common/pages/pagesUtils';
import { getTranslations } from 'modules/app/intl/selectors';
import { DEFAULT_LANGUAGE, getLocaleUsage } from 'constants/LanguageConstants';
import { getBrandingName, getDealerTimezone } from 'modules/entity/selectors';

import SimplePage from './SimplePage';

/** @type {React.FC} */
const ErrorPageContent = ({ message = getDefault404Message() }) => {
  const intl = useIntl();
  const name = useSelector(getBrandingName);

  const title = intl.formatMessage({ id: 'web.error.page.title', defaultMessage: '{name} - Error' }, { name });

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div id="page-wrapper" className="page">
        <SimplePage>{message}</SimplePage>
      </div>
    </>
  );
};

/**
 * @typedef {{
 *  language?: string,
 * }} Page404Props
 */

/** @type {React.FC<Page404Props>} */
const Page404 = ({ language = getLocaleUsage(DEFAULT_LANGUAGE), children }) => {
  const timezone = useSelector(getDealerTimezone);
  const translations = useSelector(getTranslations);

  return (
    <IntlProvider messages={translations} locale={language} timeZone={timezone}>
      <ErrorPageContent message={children} />
    </IntlProvider>
  );
};

export default Page404;
